import { makeAutoObservable } from 'mobx'

import { Collection } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { UnionNavItemModel } from '../../types'

import NavItemModel from '../models/NavItemModel/NavItemModel'
import SectionNavItemModel from '../models/SectionNavItemModel/SectionNavItemModel'

class NavbarStore {
   private applicationNavItemsCollection!: Collection<string, NavItemModel>
   private allNavItemsCollection!: Collection<string, UnionNavItemModel>
   private _pipelinesNavItem!: SectionNavItemModel | null

   private _templatesNavItem!: SectionNavItemModel | null

   constructor() {
      this.init()

      makeAutoObservable(this, {}, { autoBind: true })
   }

   private init = (): void => {
      this.applicationNavItemsCollection = new Collection<string, NavItemModel>(
         'The navItem you are looking for does not exist'
      )
      this.allNavItemsCollection = new Collection<string, UnionNavItemModel>(
         'The navItem you are looking for does not exist'
      )
      this._pipelinesNavItem = null
      this._templatesNavItem = null
   }

   get applicationNavItems(): NavItemModel[] {
      return this.applicationNavItemsCollection.orderedItems
   }

   get pipelinesNavItem(): SectionNavItemModel | null {
      return this._pipelinesNavItem
   }

   get navItems(): UnionNavItemModel[] {
      return this.allNavItemsCollection.orderedItems
   }

   addNavItem(navItem: UnionNavItemModel): void {
      this.allNavItemsCollection.addItem(navItem.id, navItem)
   }

   addApplicationNavItem(navItem: NavItemModel): void {
      this.applicationNavItemsCollection.addItem(navItem.id, navItem)
   }

   setPipelinesNavItem(navItem: SectionNavItemModel | null): void {
      this._pipelinesNavItem = navItem
   }

   deleteNavItem(navItemId: string): void {
      this.allNavItemsCollection.deleteItem(navItemId)
   }

   deleteApplicationNavItem(navItemId: string): void {
      this.applicationNavItemsCollection.deleteItem(navItemId)
   }

   addPipelineNavItem(navItem: SectionNavItemModel): void {
      this._pipelinesNavItem = navItem
   }

   hasNavItem(id: string): boolean {
      return this.allNavItemsCollection.hasItem(id)
   }

   getNavItem(id: string): UnionNavItemModel {
      return this.allNavItemsCollection.getItem(id)
   }

   private openNavItem(navItem: UnionNavItemModel): void {
      navItem?.setIsOpen(true)
   }

   openAllParentNavItems(id: string): void {
      const navItem = this.getNavItem(id)

      if (navItem?.parent) {
         const navItemParent = navItem.parent

         this.openNavItem(navItemParent)

         return this.openAllParentNavItems(navItem?.parent.id)
      }

      return
   }

   addTemplateNavItem = (navItem: SectionNavItemModel): void => {
      this._templatesNavItem = navItem
   }

   get templatesNavItem(): SectionNavItemModel | null {
      return this._templatesNavItem
   }

   clearStore(): void {
      this.init()
   }

   static createEntityRemarksStore = (): NavbarStore => new NavbarStore()
}

export default NavbarStore
